<div class="product-container"
     [mmTestId]="'ORDER_HISTORY.ORDER_LINE_ITEM'">
  <app-order-line-actions-bar [orderLine]="orderLine"
                              [orderId]="orderId"
                              [isContactEmailFeatureEnabled]="isContactEmailFeatureEnabled"
                              [isGetInvoiceFeatureEnabled]="isGetInvoiceFeatureEnabled"
                              [isSubsidiaryAccount]="isSubsidiaryAccount"
                              [isMobileOrTablet]="isMobileOrTablet">
  </app-order-line-actions-bar>

  <div class="product-content"
       [class.product-content--divider]="!isLastOrderLine">
    <div class="product-content__info-block">
      <div>
        <div class="product-content__img-wrapper">
          <app-link-ga-tracking [linkType]="'img'"
                                   [imageSource]="(orderLine?.product?.imageUrl || productPlaceholderUrl)"
                                   [redirectLink]="'/' + APP_PRODUCT_ROUTE + '/' + orderLine?.product?.productId"
                                   [isLinkDisabled]="isSubsidiaryAccount"
                                   [label]="orderLine?.product?.name">
          </app-link-ga-tracking>
        </div>
        <div class="product-content__sold-by-text-non-desktop">
          <ng-container [ngTemplateOutlet]="sold_by"></ng-container>
        </div>
      </div>
      <div class="product-content__delivery-section">
        <div class="product-content__status-container">
          <div class="product-content__status"
               [mmTestTarget]="'order-line-status-' + orderLine?.status?.value"
               [ngClass]="'product-content__status-' + (statusClassName[orderLine?.status?.value] || orderLine?.status?.value)">
            {{ orderLine?.status?.title }}
          </div>

          <span class="product-content__date-label">
                        <ng-container *ngIf="orderLine?.status?.value === orderStatus.CONFIRMED">
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_DATE_ON_CONFIRMED_STATUS.LABEL' | translate }}
                        </ng-container>
                        <strong>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_STATUS_CHANGED_ON' | translate }}</strong>
                    </span>
          <strong>{{ orderLine?.updatedAt | date: 'MMM d, yyyy' }}</strong>
        </div>

        <div *ngIf="isWaitingForPayment && isFailed"
             [mmTestTarget]="'failed-reason'">
                <span class="mr-gutter-xs">
                    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_REASON_LABEL' | translate }}:
                </span>
          <span>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE.FAILED.REASON.VALUE' | translate }}</span>
        </div>

        <div *ngIf="isCancelled"
             [mmTestTarget]="'cancellation-reason'">
                    <span class="mr-gutter-xs">
                        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_REASON_LABEL' | translate }}:
                    </span>
          <span>
                        {{ orderLine?.cancellationReason?.title || ('PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE.DEFAULT_CANCELLATION_REASON' | translate) }}
                    </span>

          <div *ngIf="orderLine?.cancellationReason?.value === cancellationReasons.CANCELLED_BY_CUSTOMER_SUPPORT">
                        <span class="mr-gutter-xs">
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_CANCELED_BY_LABEL' | translate }}:
                        </span>
            <span>
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_CUSTOMER_SUPPORT.VALUE' | translate }}
                        </span>
          </div>
        </div>

        <div *ngIf="orderLine?.returnReason?.title && isEnabledReturnReason"
             [mmTestTarget]="'return-reason'">
                      <span class="mr-gutter-xs">
                          {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_RETURN_REASON_LABEL' | translate }}:
                      </span>
          <span>{{ orderLine.returnReason.title }}</span>
        </div>

        <div *ngIf="orderLine?.returnedBy?.title && isEnabledReturnReason"
             [mmTestTarget]="'returned-by'">
                      <span class="mr-gutter-xs">
                          {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_RETURNED_BY.LABEL' | translate }}:
                      </span>
          <span>{{ orderLine.returnedBy.title }}</span>
        </div>

        <div *ngIf="isReturnRejected && orderLine?.returnResolution"
             class="product-content__rejection-reason"
             #rejectionReason
             [mmTooltipClass]="'rejection-reason-tooltip'"
             [mmTooltip]="fullResolution"
             [mmTooltipDisabled]="!(rejectionReason.offsetHeight | isTruncatedByCss: rejectionReason.scrollHeight)"
             [mmTestTarget]="'return-reason'">
              <span class="mr-gutter-xs">
                  {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_REJECTION_REASON_LABEL' | translate }}:
              </span>
          <span>{{ orderLine.returnResolution }}</span>
          <ng-template #fullResolution>{{ orderLine.returnResolution }}</ng-template>
        </div>

        <div class="product-content__ppi">
          <div class="mr-gutter-xs">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_PPI' | translate }}:</div>
          <div>
            <span [mmTestTarget]="'order-line-quantity'">{{ orderLine?.quantity }}</span>
            X
            <span
              [mmTestTarget]="'order-line-unit-price'">{{ unitPrice?.amount | currency : unitPrice?.currency }}</span>
            <span class="vat"> {{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: {exclude: isEntrepreneur} }}</span>
          </div>
        </div>

        <app-order-line-delivery [expectedDeliveryPeriod]="orderLine?.expectedDeliveryPeriod"
                                 [trackings]="orderLine?.trackings"
                                 [status]="orderLine?.status?.value">
        </app-order-line-delivery>
      </div>
    </div>
    <div class="product-content__info-block product-content__info-block--finance-section">
      <ng-container>
        <div class="product-content__finance-row">
          <div>
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_PRICE' | translate }}
            <span class="vat">{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: {exclude: isEntrepreneur} }}</span>
          </div>
          <div [mmTestTarget]="'order-line-subtotal-price'">
            {{ price?.amount | currency : price?.currency }}
          </div>
        </div>

        <div class="product-content__finance-row">
          <div>
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_SHIPPING' | translate }}
            <span class="vat">{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: {exclude: isEntrepreneur} }}</span>
          </div>
          <div
            [mmTestTarget]="'order-line-shipping-price'">{{ shippingCost?.amount | currency : shippingCost?.currency }}</div>
        </div>

        <div *ngIf="isEntrepreneur">
          <div class="product-content__finance-row" [ngClass]="{'bold': discount?.amount <= 0}">
            <div>
              {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}
              <span class="vat">{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: {exclude: isEntrepreneur} }}</span>
            </div>
            <div [mmTestTarget]="'order-line-subtotal-shipping-price'">
              {{ totalPriceNet?.amount | currency : totalPriceNet?.currency }}
            </div>
          </div>
          <div class="product-content__finance-row">
            <div>
              {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}
              <span class="vat">{{ 'CART.TOTALS.TOTAL.VAT_INFO' | translate }}</span>
            </div>
            <div [mmTestTarget]="'order-line-subtotal-vat-price'">
              {{ totalPriceGross?.amount | currency : totalPriceGross?.currency }}
            </div>
          </div>
        </div>

        <div *ngIf="isDiscountApplied">
          <div class="product-content__finance-row">
            <div>
              <strong>{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_DISCOUNT" | translate }}</strong>
              <span class="vat"> {{ "CART.TOTALS.TOTAL.VAT_INFO" | translate }}</span>
            </div>
            <div [mmTestTarget]="'order-line-discount'">
              <strong>-{{ discount?.amount | currency : discount?.currency }}</strong>
            </div>
          </div>
          <div class="product-content__finance-row discount-applied">
            <div>
              <strong>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}</strong>
              <span class="vat"> {{ "CART.TOTALS.TOTAL.VAT_INFO" | translate }}</span>
            </div>
            <div [mmTestTarget]="'order-line-total-price'">
              <strong>{{ grandTotal?.amount | currency : grandTotal?.currency }}</strong>
            </div>
          </div>
        </div>

        <div *ngIf="!isDiscountApplied && !isEntrepreneur" class="product-content__finance-row">
          <div>
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}
            <span class="vat"> {{ "CART.TOTALS.TOTAL.VAT_INFO" | translate }}</span>
          </div>
          <div [mmTestTarget]="'order-line-subtotal-price'">
            {{ grandTotal?.amount | currency : grandTotal?.currency }}
          </div>
        </div>
      </ng-container>

    </div>
    <div class="product-content__button-block">
      <div class="product-content__info-block product-content__sold-by-text-desktop">
        <ng-container [ngTemplateOutlet]="sold_by"></ng-container>
      </div>
      <div class="product-content__contact-section">
        <button  [mmTestTarget]="'order-line-buy-it-again-button'" mm-button
                *ngIf="orderLine?.isBuyAgain && isBuyAgainButtonEnable"
                class="buy-it-again-button"
                [color]="'primary'"
                [routerLink]="[buyAgainRoute]"
                [queryParams]="{id: orderLine?.product?.productId}"
                (click)="sendGAEventBuyAgain()">
          {{ 'ORDER_HISTORY.ORDER_LINE.BUY_AGAIN' | translate }}
        </button>
        <button mm-button
                class="contact-button contact-button-experiment"
                *ngIf="!isSubsidiaryAccount && !(isContactEmailFeatureEnabled &&
                  !(metroIdOrganization === orderLine.seller.id))"
                [color]="'secondary'"
                (click)="createSupportTicket(orderLine?.orderLineId)">
          {{ 'ORDER_HISTORY.ORDER_LINE.CONTACT_SELLER' | translate }}
        </button>
        <button [mmTestTarget]="'order-line-contact-seller-button'" mm-button
                class="contact-button contact-button-experiment"
                [color]="'secondary'"
                fluid
                mmContextualMenu
                *ngIf="!isSubsidiaryAccount && (isContactEmailFeatureEnabled &&
                  !(metroIdOrganization === orderLine.seller.id))"
                [mmContent]="contentTemplate">
          <div class="button-content">
            <span> {{ 'ORDER_HISTORY.ORDER_LINE.CONTACT_SELLER' | translate }}</span>
            <mm-icon class="down-arrow" name="chevron-down"></mm-icon>
          </div>
        </button>
        <ng-template #contentTemplate>
          <mm-contextual-menu-item
            (click)="contactSeller('REQUEST_DELIVERY_TIME')"
          >
            {{ 'ORDER_HISTORY.ORDER_LINE.REQUEST_DELIVERY_TIME' | translate }}
          </mm-contextual-menu-item>
          <mm-contextual-menu-item
            (click)="contactSeller('OTHER_ENQUIRY')"
          >
            {{ 'ORDER_HISTORY.ORDER_LINE.OTHER_ENQUIRY' | translate }}
          </mm-contextual-menu-item>
        </ng-template>
      </div>
    </div>
  </div>
</div>
<ng-template #sold_by>
  <p [mmTestTarget]="'order-line-seller-name'">
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_SOLD_BY' | translate }}:
    <a [routerLink]="[sellerRoute, orderLine?.seller?.id]"
       (click)="navigateToSellerClicked()">
      {{ orderLine?.seller?.shopName }}
    </a>
  </p>
</ng-template>
